import { computed, ref, toValue, type MaybeRefOrGetter } from 'vue';

// The "Mostrar anulados" switch of a list of registros clínicos: anulados are
// hidden until the user asks for them, and the switch only shows when the
// list has any.
export function useShowVoided<T extends { voided?: boolean }>(
  items: MaybeRefOrGetter<T[] | null | undefined>,
) {
  const showVoided = ref(false);
  const voidedCount = computed(() => (toValue(items) ?? []).filter(item => item.voided).length);
  const visibleItems = computed(
    () => (toValue(items) ?? []).filter(item => showVoided.value || !item.voided),
  );

  return { showVoided, voidedCount, visibleItems };
}
